import React from 'react';
import { Task } from '../types';
import { AlertTriangle, Clock, Coffee, CheckCircle2 } from 'lucide-react';

const priorityIcons = {
  urgent: <AlertTriangle className="w-5 h-5 text-[#ff00c1]" />,
  normal: <Clock className="w-5 h-5 text-[#f7d000]" />,
  leisure: <Coffee className="w-5 h-5 text-[#00fff9]" />
};

interface TaskListProps {
  tasks: Task[];
  onTaskClick: (task: Task) => void;
}

export const TaskList: React.FC<TaskListProps> = ({ tasks, onTaskClick }) => {
  return (
    <div className="space-y-4">
      {tasks.map((task) => (
        <div
          key={task.id}
          onClick={() => onTaskClick(task)}
          className={`cyberpunk-card rounded-lg p-4 cursor-pointer border-l-4 hover:scale-[1.02] transition-all duration-300 ${
            task.status === 'completed' ? 'opacity-75' : ''
          }`}
          style={{
            borderLeftColor:
              task.priority === 'urgent'
                ? '#ff00c1'
                : task.priority === 'normal'
                ? '#f7d000'
                : '#00fff9',
          }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              {priorityIcons[task.priority]}
              <h3 className="font-mono font-bold text-gray-100">{task.title}</h3>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-sm text-gray-400 font-mono">
                {new Date(task.dueDate).toLocaleDateString()}
              </div>
              {task.status === 'completed' && (
                <CheckCircle2 className="w-5 h-5 text-[#00fff9]" />
              )}
            </div>
          </div>
          
          <div className="mt-2">
            <div className="text-sm text-gray-400 mb-2">{task.description}</div>
            <div className="w-full bg-gray-800 rounded-full h-2">
              <div
                className="rounded-full h-2 transition-all duration-300"
                style={{
                  width: `${task.progress}%`,
                  background: `linear-gradient(90deg, #00fff9, ${
                    task.priority === 'urgent'
                      ? '#ff00c1'
                      : task.priority === 'normal'
                      ? '#f7d000'
                      : '#00fff9'
                  })`
                }}
              />
            </div>
            <div className="text-xs text-gray-500 mt-1 font-mono">
              PROGRESS: {task.steps.filter(step => step.completed).length} / {task.steps.length}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};